import { message } from "antd"

/**
 * Will duplicate the item and place it at the end of the list
 * @param copiedItem
 * @return {(function(*, *): void)|*}
 */
export const duplicateSpecificObjectiveSubItems = (copiedItem) => (items, setNewItems) => {
  const sortedByOrderIdx = (items || [])
    .sort((a, b) => a.orderIndex - b.orderIndex)

  // put item at the end
  copiedItem.orderIndex = items.length + 1
  sortedByOrderIdx.push(copiedItem)

  setNewItems(sortedByOrderIdx)
  message.info('Duplicado correctamente')
}
